export default __webpack_public_path__ + "static/media/caffe2.6a4eaeba.svg";